import type { IAnnouncementBarRepository } from '../repository/IAnnouncementBarRepository'
import type { AnnouncementBar } from '../blocs/AnnouncementBar'
import { NATIONAL_SCOPE } from '../utils/constantes'
import type { DisplayOnPage } from '../blocs/AnnouncementBar'
import { sortMappedBlocsBySegmentPriority } from '../utils/filterContentListBySegment'

export interface AnnouncementBarUseCase {
  getPageDisplayOn(routeName: string): DisplayOnPage | undefined
  getAnnouncementBar(
    tags: string[],
    routeName: string,
    isAuthenticated?: boolean,
    partnerId?: number,
  ): Promise<AnnouncementBar | null>
}

const routeToDisplayOn = {
  home: 'Home Page',
  'portal-shop': 'Home Page',
  'farmi-app-appro-categories': 'Home Page',
  product: 'Product Page',
  search: 'Liste of products page',
  category: 'Liste of products page',
  cart: 'Cart',
}

export function getAnnouncementBarUseCaseFactory(
  announcementBarRepository: IAnnouncementBarRepository,
): AnnouncementBarUseCase {
  async function getAnnouncementBar(
    tags: string[],
    routeName: string,
    isAuthenticated?: boolean,
    partnerId?: number,
  ): Promise<AnnouncementBar | null> {
    const partnerScope = isAuthenticated ? String(partnerId) : NATIONAL_SCOPE
    const currentPageDisplayOn = getPageDisplayOn(routeName)
    // with unknown displayOn page, no possible query
    if (!currentPageDisplayOn) return null
    const displayOn: DisplayOnPage[] = ['All pages', currentPageDisplayOn]

    const announcementBars = await announcementBarRepository.getAnnouncementBarsByFilter(
      {
        tags,
        displayOn,
      },
      partnerScope,
    )
    // sort the response by segment priority
    announcementBars.sort(sortMappedBlocsBySegmentPriority(tags))
    return announcementBars?.length ? announcementBars[0] : null
  }

  function getPageDisplayOn(routeName: string): DisplayOnPage | undefined {
    return routeToDisplayOn[routeName]
  }

  return {
    getPageDisplayOn,
    getAnnouncementBar,
  }
}
